import axios from "axios";
import { TabIOCForm } from "../pages/ioc/TabIOC";
import { Catalogos } from "./Catalogos";

export class IOCServiceDos {

    public async consultaIOC(form:TabIOCForm) {
        const cuboIOC:string = 'CIOC' ; // Tipo: Cubo Indicadores Otorgamiento de Crédito
        
        let dimsVal:string='';
        let mtrsVal:string='';
        
        Catalogos.CAT_VARIABLES.json.forEach( (item,i) => {
            if ( Object.getOwnPropertyDescriptor(form, item.Id ) !== undefined && Object.getOwnPropertyDescriptor(form, item.Id )?.value !== '' ) {
                dimsVal+=item.Id;
                dimsVal+=',';
            }
        })
        
        Catalogos.CAT_CUBO_RAMAS.json.forEach( (item,i) => {
            if ( Object.getOwnPropertyDescriptor(form, item.Id ) !== undefined && Object.getOwnPropertyDescriptor(form, item.Id )?.value !== '' ) {
                mtrsVal+=item.Id;
                mtrsVal+=',';
            }
        })
        
        if( mtrsVal === '' ) {
            throw new Error( 'Selecciona las metricas.' );
        } else {
            if ( mtrsVal.split(',').length<1 ) {
                if ( form.R2_01 === '' ) {
                    throw new Error( 'Selecciona una o dos metricas.' );
                } else {
                    if(form.CV_ZONA_CNSN_URBA === '' && form.CV_NVEL_MVLD_ADCA === '' ) {
                        throw new Error( 'Selecciona algúna variable ZCU.' );
                    }
                }
            }
        }

        if( dimsVal === '' ) {
            throw new Error( 'Selecciona de 1 a 4 variables.' );
        }
        
        if( form.fechaInicio.valueOf() < Catalogos.MIN_DATE.valueOf() || form.fechaFin.valueOf() < Catalogos.MIN_DATE.valueOf() ) {
            throw new Error( 'Selecciona el periodo.' );
        }
        if( form.CV_ZONA_CNSN_URBA !== '' || form.CV_NVEL_MVLD_ADCA !== '' ) {
            if( form.fechaInicio.valueOf() < Catalogos.MIN_ZCU_DATE.valueOf() ) {
                throw new Error( 'La Fecha inicio debé ser a partir de 2022.' );
            }
        }
        if( form.fechaInicio.valueOf() > form.fechaFin.valueOf() ) {
            throw new Error( 'La Fecha fin debé ser posterior a la Fecha inicio.' );
        }
        
        const data = await axios.get(
                process.env.REACT_APP_CONTEXT_PATH_REST + '/procesaFicheroRest?' +
                    'dims=dimsVal&mtrs=mtrsVal&per=perVal&mes=mesVal&tipo=tipoVal'
                        .replaceAll( 'dimsVal', dimsVal )
                        .replaceAll( 'mtrsVal', mtrsVal )
                        .replaceAll( 'perVal', 'pai,pmi,paf,pmf'.replaceAll( 'pai', form.fechaInicio.getFullYear()+'' ).replaceAll( 'pmi', ( form.fechaInicio.getMonth() + 1 ) + '' ).replaceAll( 'paf' , form.fechaFin.getFullYear() + '' ).replaceAll( 'pmf', ( form.fechaFin.getMonth() + 1 ) + '' ) )
                        .replaceAll( 'mesVal', form.rutaTematicaMes )
                        .replaceAll( 'tipoVal', cuboIOC )
                , {
                    responseType: 'blob',
                }
            ).then((res) => {
                return res.data;
            });

        return data;
    }
}